export default "__VITE_ASSET__CVj00hW9__"